import _ from 'lodash';

export const createTranslationKey = (baseKeyPath: string, value: string) => {
    const toCamelCase = str => {
        return _.camelCase(str);
    };
    return `${baseKeyPath}.${toCamelCase(value)}`;
};
